// extracted by mini-css-extract-plugin
module.exports = {"page":"CookbookPdf_page__3ukTP","pro":"CookbookPdf_pro__2ONhC","badge":"CookbookPdf_badge__1WtWm","buttons":"CookbookPdf_buttons__1sAS0"};